import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Borrow ideas</div>
                                            <p>Borrow ideas from other contexts instead of trying to
                                                ‘re-invent the wheel’. For example, you might want to make
                                                people more aware of health and safety issues by researching
                                                and discussing famous, major disasters which have resulted
                                                from minor causes or lapses in personal and collective
                                                responsibility. Ask people to consider the possible
                                                implications of similar behaviour in your own place of
                                                work.</p>
                                            <div className="border_subtitle">See it from another angle</div>
                                            <p>Re-define the issue with one of the following techniques:</p>
                                            <div className="paraspace"><p><span
                                                className="green"><strong>Brain drop</strong></span>
                                            </p></div>
                                            <ul className="greenbullet-list uiheading">
                                                <li><p>Keep a notepad or create a wall chart for ideas about
                                                    a particular issue as they come up, rather than trying
                                                    to force them at a particular a time.</p></li>
                                                <li><p>Use materials that help you feel creative – coloured
                                                    pens, crayons, etc.</p></li>
                                                <li><p>Try not to censor your thoughts; write down
                                                    everything and then revisit it to see what could be
                                                    developed.</p></li>
                                            </ul>
                                            <p></p>
                                            <div className="paraspace"><p><span className="green"><strong>How might a child see this?</strong></span>
                                            </p></div>
                                            <ul className="greenbullet-list uiheading">
                                                <li style={{paddingBottom: '15px !important'}}>Try to let go of
                                                    your preoccupations and imagine how a young child might
                                                    see the issue –this could reduce it to its basic
                                                    elements and reveal a new insight or solution.
                                                </li>
                                            </ul>
                                            <div className="paraspace"><p><span
                                                className="green"><strong>Draw it</strong></span>
                                            </p></div>
                                            <ul className="greenbullet-list sept">
                                                <li>Sketch it. Imagine you’re explaining the idea to a
                                                    client by drawing on a flipchart – it may help explain
                                                    it more clearly to yourself and highlight things you’ve
                                                    overlooked.
                                                </li>
                                                <li>Find different words to describe the issue. We use
                                                    particular buzz words and other jargon without
                                                    considering what they really mean or their
                                                    appropriateness in a particular context. For example,
                                                    find replacements for the word ‘diversity’ to consider
                                                    its practical implications in terms of employment law.
                                                </li>
                                            </ul>
                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">USE A REFRAMING MATRIX</span>
                                            </div>
                                            <p>People approach problems in different ways. Think of the way
                                                someone you know might deal with yours.</p>
                                            <p>Write a few words representing the problem in the centre of a
                                                grid. Use the surrounding boxes to describe the different
                                                ways you think others might interpret it – and what they’d
                                                suggest.</p>
                                            <div className="uiheading"><p
                                                style={{paddingBottom: '20px !important'}}>Use the grid to look
                                                at the issue/opportunity from the following viewpoints:
                                                Product, Planning, Potential and People.</p></div>
                                            <div
                                                className="lightgreencontentbg uiheading lightbgcenter separator-pad">
                                                <p><span
                                                    className="green"><strong>Product perspective:</strong></span> Is
                                                    there something wrong with the product?</p>
                                            </div>
                                            <div
                                                className="lightgreencontentbg uiheading lightbgcenter separator-pad">
                                                <p><span
                                                    className="green"><strong>Planning perspective:</strong></span> Are
                                                    business or marketing plans faulty?</p>
                                            </div>
                                            <div
                                                className="lightgreencontentbg uiheading lightbgcenter separator-pad">
                                                <p><span
                                                    className="green"><strong>Potential perspective:</strong></span> If
                                                    targets were increased, how would we achieve them?</p>
                                            </div>
                                            <div className="lightgreencontentbg uiheading lightbgcenter">
                                                <p><span
                                                    className="green"><strong>People perspective:</strong></span> Why
                                                    do people choose one product over another?</p>
                                            </div>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}